export default {"src":"/_next/static/media/cdo-logo-inverse.062eac04.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};